export function emptyFunction(): void {
}

export function returnTrue(): boolean {
    return true;
}

export function returnFalse(): boolean {
    return false;
}

export function handleApiCall(apiCall: () => Promise<unknown>, thenCallback: (result: unknown) => void = emptyFunction, catchCallback: (error: unknown) => void = emptyFunction): void {
    apiCall()
        .then((result) => {
            thenCallback(result);
        })
        .catch((error) => {
            catchCallback(error);
        });
}
